import type { DeepPartial } from '@luna/utils-ts';
import type { CurrentAccountSettingsDetailsConfig } from '@shared/products-feature-configs';

export const settingsDetails: DeepPartial<CurrentAccountSettingsDetailsConfig> = {
    displayAccountOwner: true,
    displayCreationDate: true,
    displayDebitInterestRate: true,
    displayBalance: true,
    displaySpacedBBAN: true,
    displayIBANForFxAccount: true,
    displayBICForFxAccount: true,
    displayOverdraft: true,
    displayOverdraftApprovedLimit: true,
    displayOverdraftDateSpan: true,
    disableBICCopyAction: true,
    subtypeDependentAccountNumberCopyAction: true,
};
